// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import buttonSizeVariants from "@insite/mobius/Button/buttonSizeVariants";
import get from "@insite/mobius/utilities/get";

const buttonShapes = {
    pill: ({ _sizeVariant, _size }: { _sizeVariant?: keyof typeof buttonSizeVariants; _size?: number }) => {
        const diameter = _size || get(buttonSizeVariants, [_sizeVariant, "height"]);
        return `border-radius: ${diameter / 2}px;`;
    },
    rounded: () => `
        border-radius: 2px;
    `,
};

export default buttonShapes;
